module.exports = __webpack_public_path__ + "img/1.4d0f79a7.png";